import React from 'react';
import { useSelector } from 'react-redux';

import { NVLoadingPlaceholderPanel } from 'shared/components/nv-loading-placeholder';
import { getNpsCsatConfiguration, getNpsCsatSummary, getNpsCsatSummaryLoading } from 'redux/selectors/analytics';
import { NpsCsatConfig, NpsCsatSummary } from 'redux/schemas/app/analytics';
import NpsCsat from './nps-csat';
import NpsCsatStatWrapper from './nps-csat-stat-wrapper';

const NpsCsatLoader = () => (
  <React.Fragment>
    <NVLoadingPlaceholderPanel height='200px' width='200px' />
    <div className='flex-grow-1'>
      <NVLoadingPlaceholderPanel height='200px' width='100%' />
    </div>
  </React.Fragment>
);

const NpsCsatPanel = () => {
  const npsCsatConfig: NpsCsatConfig | null | undefined = useSelector(getNpsCsatConfiguration);
  const isConfigured = Boolean(npsCsatConfig?.configured);
  const npsCsatSummary: NpsCsatSummary | null | undefined = useSelector(getNpsCsatSummary);
  const npsCsatSummaryLoading = useSelector(getNpsCsatSummaryLoading);

  if (!isConfigured) return null;

  if (npsCsatSummaryLoading) {
    return (
      <NpsCsatStatWrapper>
        <NpsCsatLoader />
      </NpsCsatStatWrapper>
    );
  }

  if (!npsCsatSummary) return null;

  return (
    <NpsCsat npsCsatSummary={npsCsatSummary} />
  );
};

export default NpsCsatPanel;
